import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Button from './Basic/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },

    '&[data-class="footer"]': {
      paddingBottom: theme.spacing(2),
    },

    '& button': {
      '&.Mui-disabled': {
        boxShadow: 'none',
      },

      '&:first-child': {
        borderRadius: '4px 0 0 4px',
      },

      '&:last-child': {
        borderRadius: '0 4px 4px 0',
      },
    },
  },
}));

const Pagination = ({
  footer,
  onPaginationChange,
  prev = null,
  next = null,
  loading,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} data-class={footer ? 'footer' : ''}>
      <Button
        disabled={!prev || loading}
        startIcon={<NavigateNextIcon style={{ transform: 'rotate(180deg)' }} />}
        color="primary"
        onClick={() => onPaginationChange(prev)}
      >
        Prev
      </Button>
      <Button
        disabled={!next || loading}
        endIcon={<NavigateNextIcon />}
        color="primary"
        onClick={() => onPaginationChange(next)}
      >
        Next
      </Button>
    </div>
  );
};

Pagination.defaultProps = {
  errorHandeler: () => {},
  footer: false,
  loading: false,
  onPaginationChange: () => {},
};

Pagination.propTypes = {
  errorHandeler: PropTypes.func,
  footer: PropTypes.bool,
  onPaginationChange: PropTypes.func,
  loading: PropTypes.bool,
};

export default Pagination;
